import { Typography } from '@mui/material';
import { Box } from '@mui/system';
import { ScopeT } from 'business/definitions';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { isScopeRestrictedWithoutBlock } from 'routes/Admin/UserManagement/Users/CreateOrEditUser/components/ScopeFormStep/helpers/blockValues';
import { shouldDisplayScope } from 'routes/Admin/UserManagement/Users/CreateOrEditUser/components/ScopeFormStep/helpers/scopes';
import { ScopeFormStep } from 'routes/Admin/UserManagement/Users/CreateOrEditUser/components/ScopeFormStep/ScopeFormStep';
import { useUserCreationFormContext } from 'routes/Admin/UserManagement/Users/CreateOrEditUser/CreateUserContext/CreateUserFormContext';
import { ModalStepT } from 'ui/Modals/MultiStepModal';

export const useGetScopeFormSteps = (scopes: ScopeT[]): ModalStepT[] => {
    const { t } = useTranslation();
    const {
        roles,
        scopes: userScopes,
        writeScopes: userWriteScopes,
    } = useUserCreationFormContext();

    const scopesToDisplay = scopes.filter((scope) =>
        shouldDisplayScope(scope, roles),
    );

    return scopesToDisplay.map((scope) => {
        const canGoToNextStepForScope = !isScopeRestrictedWithoutBlock(
            userScopes,
            scope,
        );
        const canGoToNextStepForWriteScope = !isScopeRestrictedWithoutBlock(
            userWriteScopes,
            scope,
        );
        const isNextStepEnabled =
            canGoToNextStepForScope && canGoToNextStepForWriteScope;
        return {
            title: (
                <Box sx={{ mb: 2 }}>
                    <Typography variant="h4">
                        {t('adminSpace.createUser.dialogTitle', {
                            section: scope.label,
                        })}
                    </Typography>
                    <Typography sx={{ mt: 2 }}>
                        {t(
                            'adminSpace.createUser.modalStepper.scopeSection.subtitle',
                        )}
                    </Typography>
                </Box>
            ),
            node: <ScopeFormStep scope={scope} />,
            confirmAction: {
                enabled: isNextStepEnabled,
                tooltipMessage: isNextStepEnabled
                    ? undefined
                    : t('userFormValidation.incompleteRestrictedScope'),
            },
        };
    });
};
